const MILLIMETERS_PER_INCH = 25.4;

// Cartamundi's production poker-card format is 63 x 88 mm. Abbiati's
// casino-quality 10 g poker chip is 39 mm across and 3 mm thick.
export const POKER_CARD_SIZE_MM = Object.freeze({ width: 63, height: 88 });
export const POKER_CHIP_SIZE_MM = Object.freeze({ diameter: 39, thickness: 3 });

export const POKER_CARD_SIZE_INCHES = Object.freeze({
  width: POKER_CARD_SIZE_MM.width / MILLIMETERS_PER_INCH,
  height: POKER_CARD_SIZE_MM.height / MILLIMETERS_PER_INCH,
});

export const POKER_CHIP_SIZE_INCHES = Object.freeze({
  diameter: POKER_CHIP_SIZE_MM.diameter / MILLIMETERS_PER_INCH,
  thickness: POKER_CHIP_SIZE_MM.thickness / MILLIMETERS_PER_INCH,
});

export function pokerPhysicalPixels(pixelsPerInch: number) {
  const ppi = Number.isFinite(pixelsPerInch) && pixelsPerInch > 0 ? pixelsPerInch : 0;
  return {
    cardWidth: POKER_CARD_SIZE_INCHES.width * ppi,
    cardHeight: POKER_CARD_SIZE_INCHES.height * ppi,
    chipDiameter: POKER_CHIP_SIZE_INCHES.diameter * ppi,
    chipThickness: POKER_CHIP_SIZE_INCHES.thickness * ppi,
  };
}

export function calibratedWorldUnitsPerInch(pixelsPerInch: number, worldHeight: number, canvasCssHeight: number) {
  if (!Number.isFinite(pixelsPerInch) || pixelsPerInch <= 0 || !Number.isFinite(worldHeight) || worldHeight <= 0 || !Number.isFinite(canvasCssHeight) || canvasCssHeight <= 0) return 0;
  return pixelsPerInch * worldHeight / canvasCssHeight;
}
